import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ShowAllButton } from 'components/buttons/ShowAllButton';
import { CampaignsTiles } from 'components/campaign/CampaignsTiles';
import { H4 } from 'components/typography/Headers';
import { useCampaigns } from 'features/campaign/hooks/useCampaigns';
import { noContentFilters } from 'providers/CampaignFiltersProvider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

interface Props {
  resetFilters: () => void;
}

export const AvailableCampaigns = ({ resetFilters }: Props) => {
  const { t } = useTranslation('campaign');
  const { state } = useCampaigns(noContentFilters, 'Filtered');

  return (
    <Container>
      <HeaderContainer>
        <H4>{t('campaigns')}</H4>
        <ShowAllButton onClick={resetFilters} />
      </HeaderContainer>
      <CampaignsTiles campaigns={state.campaigns} hasNextPage={state.hasNextPage} />
    </Container>
  );
};
